<template>
  <div class="bg-gray-50 min-h-screen">
    <!-- Hero Section -->
    <section class="hero-bg relative py-20">      
      <!-- Content -->
      <div class="relative z-10 max-w-6xl mx-auto px-4 text-center">
        <h1 class="hero-text text-4xl md:text-5xl font-bold text-white mb-6">
          <span class="text-blue-300">แพ็กเกจ KM</span> สำหรับอบรมพนักงานภายในองค์กร
        </h1>
        <p class="hero-text text-xl text-blue-100 mb-0 max-w-4xl mx-auto">
          เลือกแพ็กเกจที่เหมาะกับขนาดองค์กรของคุณ พร้อมบริการครบวงจรสำหรับ In-House Training และทีมซัพพอร์ตมืออาชีพ
        </p>
        <!-- <div class="inline-flex items-center bg-white bg-opacity-20 backdrop-blur-sm text-white px-6 py-3 rounded-lg text-lg font-medium">
        อบรมการใช้งาน 2 ชั่วโมง
        </div> -->
      </div>
    </section>

    <!-- Package Cards Section -->
    <section class="py-8">
      <div class="max-w-6xl mx-auto px-4">
        <div class="grid md:grid-cols-3 gap-6 mb-12">
          <!-- Basic Package -->
          <div class="bg-white rounded-lg shadow-md border hover:shadow-lg transition-shadow">
            <div class="p-6">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-xl font-bold text-gray-900">Basic</h3>
                <span class="bg-blue-100 text-blue-700 text-xs px-2 py-1 rounded-full">
                  ทดลองใช้ 30 วัน
                </span>
              </div>
              <p class="text-gray-600 text-sm mb-4">เหมาะสำหรับทีม 20-100 คน</p>
              
              <div class="space-y-2 mb-6 text-sm">
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>ผู้ใช้งาน 100 คน</span>
                </div>
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>พื้นที่จัดเก็บ 10GB</span>
                </div>
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>คอร์สไม่จำกัด</span>
                </div>
              </div>
              
              <div class="border-t pt-4">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-2xl font-bold text-blue-600">฿15,000</span>
                  <span class="text-sm text-gray-500">/เดือน</span>
                </div>
                <button class="w-full bg-blue-600 text-white py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors">
                  เลือกแพ็กเกจนี้
                </button>
              </div>
            </div>
          </div>

          <!-- Professional Package -->
          <div class="bg-white rounded-lg shadow-md border-2 border-purple-200 hover:shadow-lg transition-shadow">
            <div class="p-6">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-xl font-bold text-gray-900">Professional</h3>
                <span class="bg-yellow-100 text-yellow-700 text-xs px-2 py-1 rounded-full">
                  แนะนำ
                </span>
              </div>
              <p class="text-gray-600 text-sm mb-4">เหมาะสำหรับทีม 100-1,000 คน</p>
              
              <div class="space-y-2 mb-6 text-sm">
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>ผู้ใช้งาน 1,000 คน</span>
                </div>
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>พื้นที่จัดเก็บ 100GB</span>
                </div>
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>White Label • API </span>
                </div>
              </div>
              
              <div class="border-t pt-4">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-2xl font-bold text-purple-600">฿150,000</span>
                  <span class="text-sm text-gray-500">/ปี</span>
                </div>
                <button class="w-full bg-purple-600 text-white py-2 rounded-md text-sm font-medium hover:bg-purple-700 transition-colors">
                  เลือกแพ็กเกจนี้
                </button>
              </div>
            </div>
          </div>

          <!-- Enterprise Package -->
          <div class="bg-white rounded-lg shadow-md border hover:shadow-lg transition-shadow">
            <div class="p-6">
              <div class="flex items-center justify-between mb-4">
                <h3 class="text-xl font-bold text-gray-900">White Label (ติดตั้งในองค์กร)</h3>
                <span class="bg-green-100 text-green-700 text-xs px-2 py-1 rounded-full">
                  ปรับแต่งตามต้องการ
                </span>
              </div>
              <p class="text-gray-600 text-sm mb-4">องค์กรขนาดใหญ่</p>
              
              <div class="space-y-2 mb-6 text-sm">
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>ผู้ใช้งานไม่จำกัด</span>
                </div>
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>พื้นที่จัดเก็บไม่จำกัด</span>
                </div>
                <div class="flex items-center">
                  <svg class="w-4 h-4 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span>พัฒนาตามความต้องการ • ทีมซัพพอร์ตเฉพาะทาง</span>
                </div>
              </div>
              
              <div class="border-t pt-4">
                <div class="flex items-center justify-between mb-3">
                  <span class="text-lg font-bold text-green-600">ปรึกษาราคา</span>
                </div>
                <button class="w-full bg-green-600 text-white py-2 rounded-md text-sm font-medium hover:bg-green-700 transition-colors">
                  ติดต่อเรา
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Price Calculator Section -->
        <div class="bg-white rounded-lg shadow-md border p-6">
          <div class="text-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900 mb-2">
              คำนวณราคาเพิ่มเติม
            </h2>
            <p class="text-gray-600">
              คำนวณค่าใช้จ่ายสำหรับส่วนเกินจากแพ็กเกจพื้นฐาน
            </p>
          </div>

          <div class="grid md:grid-cols-2 gap-8">
            <!-- Calculator Controls -->
            <div class="space-y-6">
              <div class="border rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-900 mb-4">
                  ผู้ใช้งานเพิ่มเติม
                </h3>
                <div class="space-y-3">
                  <div class="flex items-center justify-between text-sm">
                    <label class="text-gray-700">จำนวนผู้ใช้เพิ่มเติม</label>
                    <span class="text-gray-500">(100 คน = ฿1,000/เดือน)</span>
                  </div>
                  <div class="flex items-center space-x-3">
                    <button @click="decrementUsers" class="bg-gray-100 hover:bg-gray-200 text-gray-700 w-8 h-8 rounded-md flex items-center justify-center">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/>
                      </svg>
                    </button>
                    <input 
                      v-model.number="additionalUsers" 
                      type="number" 
                      min="0" 
                      step="100"
                      class="flex-1 px-3 py-2 border border-gray-300 rounded-md text-center focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="0"
                    >
                    <button @click="incrementUsers" class="bg-gray-100 hover:bg-gray-200 text-gray-700 w-8 h-8 rounded-md flex items-center justify-center">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                      </svg>
                    </button>
                  </div>
                  <div class="text-sm text-gray-600">
                    ฿{{ calculateUsersCost.toLocaleString() }}/เดือน
                  </div>
                </div>
              </div>

              <div class="border rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-900 mb-4">
                  พื้นที่จัดเก็บเพิ่มเติม
                </h3>
                <div class="space-y-3">
                  <div class="flex items-center justify-between text-sm">
                    <label class="text-gray-700">พื้นที่เพิ่มเติม (GB)</label>
                    <span class="text-gray-500">(250 GB = ฿1,000/เดือน)</span>
                  </div>
                  <div class="flex items-center space-x-3">
                    <button @click="decrementStorage" class="bg-gray-100 hover:bg-gray-200 text-gray-700 w-8 h-8 rounded-md flex items-center justify-center">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/>
                      </svg>
                    </button>
                    <input 
                      v-model.number="additionalStorage" 
                      type="number" 
                      min="0" 
                      step="250"
                      class="flex-1 px-3 py-2 border border-gray-300 rounded-md text-center focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      placeholder="0"
                    >
                    <button @click="incrementStorage" class="bg-gray-100 hover:bg-gray-200 text-gray-700 w-8 h-8 rounded-md flex items-center justify-center">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
                      </svg>
                    </button>
                  </div>
                  <div class="text-sm text-gray-600">
                    ฿{{ calculateStorageCost.toLocaleString() }}/เดือน
                  </div>
                </div>
              </div>
            </div>

            <!-- Calculator Results -->
            <div class="bg-gray-50 rounded-lg p-6">
              <h3 class="text-lg font-semibold text-gray-900 mb-4">
                สรุปค่าใช้จ่าย
              </h3>
              
              <div class="space-y-4">
                <div class="flex justify-between items-center py-2 border-b">
                  <span class="text-gray-700">ผู้ใช้งานเพิ่มเติม ({{ additionalUsers.toLocaleString() }} คน)</span>
                  <span class="font-semibold">฿{{ calculateUsersCost.toLocaleString() }}</span>
                </div>

                <div class="flex justify-between items-center py-2 border-b">
                  <span class="text-gray-700">พื้นที่จัดเก็บเพิ่มเติม ({{ additionalStorage.toLocaleString() }} GB)</span>
                  <span class="font-semibold">฿{{ calculateStorageCost.toLocaleString() }}</span>
                </div>

                <div class="flex justify-between items-center py-3 bg-green-50 px-4 rounded-lg border border-green-200">
                  <span class="text-lg font-semibold text-green-700">รวมค่าใช้จ่ายเพิ่มเติม</span>
                  <span class="text-xl font-bold text-green-700">฿{{ totalAdditionalCost.toLocaleString() }}/เดือน</span>
                </div>

                <div class="text-sm text-gray-600 text-center">
                  รวม VAT 7%: ฿{{ Math.round(totalAdditionalCost * 1.07).toLocaleString() }}/เดือน
                </div>

                <button class="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-md font-semibold transition-colors">
                  สร้างใบเสนอราคา
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
// Reactive state for the price calculator
import { ref, computed } from 'vue'

const additionalUsers = ref(0)
const additionalStorage = ref(0)

// Price calculation constants
const PRICE_PER_100_USERS = 1000
const PRICE_PER_250GB_STORAGE = 1000

// Computed properties for calculations
const calculateUsersCost = computed(() => {
  return Math.ceil(additionalUsers.value / 100) * PRICE_PER_100_USERS
})

const calculateStorageCost = computed(() => {
  return Math.ceil(additionalStorage.value / 250) * PRICE_PER_250GB_STORAGE
})

const totalAdditionalCost = computed(() => {
  return calculateUsersCost.value + calculateStorageCost.value
})

// Methods for increment/decrement buttons
const incrementUsers = () => {
  additionalUsers.value += 100
}

const decrementUsers = () => {
  if (additionalUsers.value >= 100) {
    additionalUsers.value -= 100
  }
}

const incrementStorage = () => {
  additionalStorage.value += 250
}

const decrementStorage = () => {
  if (additionalStorage.value >= 250) {
    additionalStorage.value -= 250
  }
}
</script>

<style scoped>
/* Hero section background */
.hero-bg {
  background-image: linear-gradient(rgba(30, 58, 138, 0.8), rgba(30, 58, 138, 0.7)), 
                    url('https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

@media (max-width: 768px) {
  .hero-bg {
    background-attachment: scroll;
  }
}

/* Remove complex animations and fancy effects */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
}

/* Text shadow for better readability */
.hero-text {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
</style>
